import { Component } from '@angular/core';

@Component({
  selector: 'authentication-shell',
  templateUrl: './authentication-shell.component.html',
  styleUrls: ['./authentication-shell.component.scss']
})
export class AuthenticationShellComponent {
}
